namespace TabAurous.OMS {
    export interface CustomerOrderRow {
        LedgerId?: number;
        PartyTypeId?: number;
        PartyType?: string;
        PartyCode?: string;
        LedgerName?: string;
        AccountGroupId?: number;
        TermId?: number;
        MailingName?: string;
        BillbyBill?: boolean;
        IsDisabled?: boolean;
        TaxRegType?: string;
        GstVat?: string;
        Pan?: string;
        Tds?: string;
        DefaultTdsType?: string;
        Tan?: string;
        LbrFlag?: string;
        StnFlag?: string;
        LbrFromDate?: string;
        LbrToDate?: string;
        LbrPricegroupId?: number;
        LbrAddDisc?: number;
        LbrAddMkp?: number;
        StnFromDate?: string;
        StnToDate?: string;
        CostPricegroupId?: number;
        StnAddDisc?: number;
        StnAddMkp?: number;
    }

    export namespace CustomerOrderRow {
        export const idProperty = 'LedgerId';
        export const nameProperty = 'PartyType';
        export const localTextPrefix = 'OMS.CustomerOrder';
        export const deletePermission = 'Customer:Delete';
        export const insertPermission = 'Customer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Customer:Edit';

        export declare const enum Fields {
            LedgerId = "LedgerId",
            PartyTypeId = "PartyTypeId",
            PartyType = "PartyType",
            PartyCode = "PartyCode",
            LedgerName = "LedgerName",
            AccountGroupId = "AccountGroupId",
            TermId = "TermId",
            MailingName = "MailingName",
            BillbyBill = "BillbyBill",
            IsDisabled = "IsDisabled",
            TaxRegType = "TaxRegType",
            GstVat = "GstVat",
            Pan = "Pan",
            Tds = "Tds",
            DefaultTdsType = "DefaultTdsType",
            Tan = "Tan",
            LbrFlag = "LbrFlag",
            StnFlag = "StnFlag",
            LbrFromDate = "LbrFromDate",
            LbrToDate = "LbrToDate",
            LbrPricegroupId = "LbrPricegroupId",
            LbrAddDisc = "LbrAddDisc",
            LbrAddMkp = "LbrAddMkp",
            StnFromDate = "StnFromDate",
            StnToDate = "StnToDate",
            CostPricegroupId = "CostPricegroupId",
            StnAddDisc = "StnAddDisc",
            StnAddMkp = "StnAddMkp"
        }
    }
}
